import { Component, DoCheck, Inject, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ENTER } from "@angular/cdk/keycodes";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { LanguageService } from "typescript";



@Component({
    selector: "json-forms-new",
    templateUrl: "./json-forms-new.component.html",
    styleUrls: ["./json-forms-new.component.scss"],
    standalone: false
})


export class JsonFormsNewComponent implements OnInit  {
  
  @Input() jsonData:any;


  @Input() title:string = 'editing.json';
  indexLines: Element[];
  currentIndex: number;
  jsonString:string='{}';
  previousUserJson:string='';
  editing = false;
  json_original:any;
  main:any;
  changingOutsite = false;
  private suppressEditorUpdate = false;


  constructor(
      @Inject(MAT_DIALOG_DATA) public dialogData,
      public dialogRef: MatDialogRef<any>,
  ){
      
  }
  
  // ngDoCheck(): void {
  //   const currentUserJson = JSON.stringify(this.jsonData, null, 2);
  //   if (currentUserJson !== this.previousUserJson && !this.changingOutsite && !this.suppressEditorUpdate) {
  //     this.previousUserJson = currentUserJson;
  //     this.jsonString = currentUserJson;
  //   }
  // }

  changingValueEvent(){
      const currentUserJson = JSON.stringify(this.jsonData, null, 2);
      if (currentUserJson !== this.previousUserJson && !this.changingOutsite && !this.suppressEditorUpdate) {
        this.previousUserJson = currentUserJson;
        this.jsonString = currentUserJson;
      }
  }

  ngOnChanges() {
    this.editing = true;
  }


  recover() {
    if (this.json_original != null) {
        this.jsonData = JSON.parse(JSON.stringify(this.json_original));
    }
  }


  ngOnInit(): void {

    if  ( this.dialogData!= null && Object.keys(this.dialogData).length > 0 ){
      try{
        this.jsonData = JSON.parse(this.dialogData.json);
      }catch(E){}
    
      this.title = this.dialogData.title;
      this.main = this.dialogData.main;
      
      try{
        this.json_original = JSON.parse(this.dialogData.json_original);
      }catch(e){
        this.json_original = JSON.parse(JSON.stringify(this.jsonData));
      }
      
    
    }else{
        this.json_original = JSON.parse(JSON.stringify(this.jsonData));
    }
    this.jsonString = JSON.stringify(this.jsonData,null,2);
    
  }
  

  onChangeJson(event){
      this.suppressEditorUpdate = true;
      this.jsonData = event;
      this.suppressEditorUpdate = false;
  }

  exportJson() {
    const json = JSON.stringify(this.jsonData, null, 2);
    // Optionally trigger download
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'edited.json';
    a.click();
    URL.revokeObjectURL(url);
  }

  searchKey: string = '';

  search(event:KeyboardEvent) {
    if ( event.keyCode == ENTER ){
      return
    };
    
    const searchKey = this.searchKey.trim();
    const regex = new RegExp(`(${searchKey})`, 'gi');

    const elements = document.querySelectorAll('strong');
    const elementsArray = Array.from(elements);
    this.indexLines = [];
    this.currentIndex = -1;

    elementsArray.forEach(el => {
      const originalText = el.textContent;
      el.innerHTML = originalText;
      if (searchKey && originalText.toLowerCase().includes(searchKey.toLowerCase())) {
        const highlightedHTML = originalText.replace(regex, `<span style="background-color: #ffe58f;">$1</span>`);
        el.innerHTML = highlightedHTML;
        this.indexLines.push(el);
      }
    });
  }

  onEnter(){
      if (this.indexLines.length === 0) return;

      this.currentIndex = (this.currentIndex + 1) % this.indexLines.length;
      this.indexLines[this.currentIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


  submit(){
    this.dialogRef.close({[this.main]:this.jsonData}  );
  }

  cancel() {
    this.dialogRef.close(false);
  }
  

}
